import { Spinner } from '@/components';
import { RoutingEndpoints } from '@/constants';
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

export default function AuthRedirect() {
  const { error } = useAuth();

  useEffect(() => {
    if (error) {
      window.location.href = RoutingEndpoints.home();
    }
  }, [error]);

  return (
    <div className="flex h-screen items-center justify-center">
      <Spinner />
    </div>
  );
}
